import React, { useEffect } from "react";
import '../scss/cp.scss';
import Logo from '../images/logo.png'
import { useLocation, useNavigate } from "react-router-dom";
import routes from "../../layout/Routes";
import Iso from './iso.png'

const Footer =()=>{
  let location=useLocation()
   useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        // Smooth scroll to the section
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    } else {
      // Default scroll to top if no hash
      window.scrollTo(0, 0);
    }
  }, [location]);
  let navigate=useNavigate()
  const gotopage=()=>{
    // window.location.href='https://carepay.money/ecommerce'
     window.open('https://carepay.money/ecommerce', '_blank')
  }
    return(
        <footer className="footer-new">
  <div className="footer-row">
    <div className="footer-col footer-brand">
      <div className="footer-logo">
       <img src={Logo} width={'150px'}/>
      </div>
      <p className="footer-desc">
        AI infrastructure for healthcare payments &amp; access — instant onboarding, explainable decisions, and reconciliation at the point of care.
      </p>
      <p className="footer-mini">SOC 2 &amp; ISO 27001 controls in place</p>
    </div>
    <div className="footer-col">
      <div className="footer-title">Products</div>
      <ul>
        <li onClick={()=>navigate(routes.CAREENA_AI)}>Careena AI</li>
        <li onClick={()=>navigate(routes.OCULON)}>Oculon</li>
        <li onClick={()=>navigate(routes.PAY_IN_PARTS)}>Pay-in-Parts</li>
        <li onClick={()=>navigate(routes.HOPEGUARD)}>HopeGuard</li>
        <li onClick={()=>navigate(routes.RECONCILE)}>Reconcile</li>
                <li onClick={()=>gotopage()}>Carepay Marketplace</li>

      </ul>
    </div>
    <div className="footer-col">
      <div className="footer-title">Company</div>
      <ul>
        <li onClick={()=>navigate(routes.ABOUT_CAREPAY)}>About</li>
        <li onClick={()=>navigate(routes.OUR_TEAM)}>Team</li>
        {/* <li>Careers</li> */}
        <li onClick={()=>navigate(routes.CONTACT_US)}>Contact</li>
      </ul>
      <h4>Address- Corporate Office</h4>
      <p>
5th Floor, DLF Two Horizon Centre,
Golf Course Road
Gurugram, Haryana, 122002, INDIA</p>
    </div>
    <div className="footer-col">
      <div className="footer-title">Legal</div>
      <ul>
        <li onClick={()=>navigate(routes.TERMS_CONDITIONS)}>Terms and Conditions</li>
        <li onClick={()=>navigate(routes.PRIVACY_POLICY_NEW)}>Privacy Policy</li>
        <li onClick={()=>navigate(routes.SECURITY)}> Security</li>
        <li onClick={()=>navigate(routes.COMPLIANCE)}>Compliance</li>
                <li onClick={()=>navigate(routes.PUBLIC_NOTICE)}>Public Note & Fraud Alert ⚠️</li>

                <li onClick={()=>navigate(routes.PRIVACY_POLICY_NEW+'#policy-16')}>Grievance Redressal Mechanism</li>
                <li onClick={()=>navigate(routes.PRIVACY_POLICY_NEW+'#policy-19')}>Consent Withdrawal Process</li>
                    <li onClick={()=>navigate(routes.LENDING_PARTNERS_NEW)}>Our
Lending Partners</li>

      </ul>
    </div>
  </div>
  <div className="footer-divider" style={{margin:'8px 0 18px 0'}}></div>
<img src={Iso} style={{width:'150px',marginLeft:'20px'}}/>
  <div className="footer-divider" style={{margin:'8px 0 18px 0'}}></div>
  <div className="footer-bottom">
    <small>
    © 2025 CarePay. All rights reserved. CarePay is owned and operated by Carecoin Technologies Private Limited. Carecoin Technologies Private Limited is responsible for the CarePay platform and related services. Financing is offered by regulated lending partners. CarePay is not a lender.    </small>
  </div>
</footer>

    )
}
export default Footer